"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = buildTOMTimeline;
require("regenerator-runtime/runtime");
// setup
const helpers_1 = require("../shared/helpers");
const taskSetup_1 = require("../taskSetup");
// trials
const trials_1 = require("../shared/trials");
const config_1 = require("./helpers/config");
const taskStore_1 = require("../../taskStore");
const preloadSharedAudio_1 = require("../shared/helpers/preloadSharedAudio");
const prepareTomCorpus_1 = require("./helpers/prepareTomCorpus");
function buildTOMTimeline(config, mediaAssets) {
    (0, helpers_1.initTrialSaving)(config);
    const initialTimeline = (0, helpers_1.initTimeline)(config, trials_1.enterFullscreen);
    const corpus = (0, taskStore_1.taskStore)().corpora.stimulus;
    const translations = (0, taskStore_1.taskStore)().translations;
    const validationErrorMap = {};
    const layoutConfigMap = {};
    for (const c of corpus) {
        const { itemConfig, errorMessages } = (0, config_1.getLayoutConfig)(c, translations, mediaAssets);
        layoutConfigMap[c.itemId] = itemConfig;
        if (errorMessages.length) {
            validationErrorMap[c.itemId] = errorMessages.join('; ');
        }
    }
    if (Object.keys(validationErrorMap).length) {
        console.error('The following errors were found');
        console.table(validationErrorMap);
        throw new Error('Something went wrong. Please look in the console for error details');
    }
    // does not matter if trial has properties that don't belong to that type
    const trialConfig = {
        trialType: 'audio',
        responseAllowed: true,
        promptAboveButtons: true,
        task: config.task,
        layoutConfigMap,
        terminateCat: false,
    };
    const initialPreload = (0, preloadSharedAudio_1.preloadSharedAudio)();
    const timeline = [initialPreload, initialTimeline];
    const blockList = (0, helpers_1.prepareMultiBlockCat)(corpus, false);
    const fillerTrials = (0, prepareTomCorpus_1.prepareTomCorpus)(blockList);
    const storyGroups = (0, prepareTomCorpus_1.prepareStoryGroups)(corpus);
    const batchedMediaAssets = (0, helpers_1.batchMediaAssets)(mediaAssets, (0, taskStore_1.taskStore)().version === 2 && storyGroups !== undefined ? storyGroups : blockList, ['item', 'answer', 'distractors'], ['audioFile', 'distractors']);
    let currPreloadBatch = 0;
    // function to preload assets in batches at the beginning of each task block
    function preloadBlock() {
        timeline.push((0, helpers_1.createPreloadTrials)(batchedMediaAssets[currPreloadBatch]).default);
        currPreloadBatch++;
    }
    const stimulusBlock = (trial) => {
        return {
            timeline: [(0, trials_1.afcStimulusTemplate)(trialConfig, trial)],
            // true = execute normally, false = skip
            conditional_function: () => {
                if ((0, taskStore_1.taskStore)().skipCurrentTrial) {
                    (0, taskStore_1.taskStore)('skipCurrentTrial', false);
                    return false;
                }
                else {
                    return true;
                }
            },
        };
    };
    const stimulusBlockCat = (currentStoryGroup) => {
        return {
            timeline: [(0, trials_1.afcStimulusTemplate)(trialConfig)],
            conditional_function: () => {
                return currentStoryGroup === (0, taskStore_1.taskStore)().currentStoryGroup;
            },
        };
    };
    (0, taskStore_1.taskStore)('totalTestTrials', (0, helpers_1.getRealTrials)(corpus));
    if ((0, taskStore_1.taskStore)().version === 2) {
        const numberOfStories = (0, taskStore_1.taskStore)().numberOfStories;
        // We can't know in advance how many trials will be in each story, so we set an arbitrarily high number
        const upperTrialLimitPerStory = 50;
        for (let i = 0; i < numberOfStories; i++) {
            preloadBlock();
            if (i === 0) {
                timeline.push(stimulusBlock(fillerTrials === null || fillerTrials === void 0 ? void 0 : fillerTrials.taskIntro));
            }
            else {
                timeline.push(stimulusBlock(fillerTrials === null || fillerTrials === void 0 ? void 0 : fillerTrials.blockTransition));
            }
            timeline.push({ ...trials_1.setupStimulusFromStoryGroup, stimulus: '' });
            for (let j = 0; j < upperTrialLimitPerStory; j++) {
                timeline.push(stimulusBlockCat(i));
            }
        }
    }
    else {
        blockList.forEach((block) => {
            preloadBlock();
            for (let i = 0; i < block.length; i++) {
                timeline.push({ ...trials_1.setupStimulus, stimulus: '' });
                timeline.push(stimulusBlock());
            }
        });
    }
    (0, taskSetup_1.initializeCat)();
    timeline.push((0, trials_1.taskFinished)());
    timeline.push(trials_1.exitFullscreen);
    return { jsPsych: taskSetup_1.jsPsych, timeline };
}
